// extracted by mini-css-extract-plugin
export var animationContainer = "_hl-0";
export var asteriskIcon = "_hl-8";
export var conversationLeftSection = "_hl-4";
export var conversationListItem = "_hl-3";
export var conversationMiddleSection = "_hl-5";
export var conversationRightSection = "_hl-6";
export var detailsContent = "_hl-1";
export var listContainer = "_hl-7";
export var modalContent = "_hl-2";